"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleTransformer = void 0;
const get_1 = __importDefault(require("lodash/get"));
const set_1 = __importDefault(require("lodash/set"));
const index_1 = require("./index");
const configurable_1 = require("../configurable");
class SimpleTransformer extends index_1.Transformer {
    get schema() {
        return {
            map: [
                configurable_1.validators.required(),
                configurable_1.validators.plainObject(),
                configurable_1.validators.notEmpty(),
            ],
        };
    }
    performTransform(data) {
        return Object.entries(this.options.map).reduce((acc, [key, value]) => {
            (0, set_1.default)(acc, key, (0, get_1.default)(data, value));
            return acc;
        }, {});
    }
}
exports.SimpleTransformer = SimpleTransformer;
//# sourceMappingURL=simple-transformer.js.map